import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../api";
import { PATIENT_STATUS } from "../../constants/api-constants";
import { ResponseModel, patientStatusProps } from "../../models/patient.model";
import { ERROR_MESSAGE } from "../../constants/variable-constants";

const getPatientStatus = createAsyncThunk(
    'patientStatus/getPatientstatus',
    async (payload: string, thunk) => {
        try {
            const response = await api.fetchAuthGet<ResponseModel<patientStatusProps[]>>(PATIENT_STATUS);
            return response.data
        } catch (error: any) {
            let errorMessage = error.response?.data?.message || ERROR_MESSAGE;
            return thunk.rejectWithValue(errorMessage)
        }
    }
)

export const PatientStatusThunkApis = { getPatientStatus };